import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MyInitialState } from "./MyState";
import { IMy, IMyFeatureGrant } from "../types";


export const MySlice = createSlice({
    name: 'my',
    initialState: MyInitialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>){
            state.isLoading = action.payload;
        },
        setError(state, action: PayloadAction<string>){
            state.error = action.payload;
        },
        setIsAuth(state, action: PayloadAction<boolean>){
            state.my.isAuth = action.payload;
        },
        setEmail(state, action: PayloadAction<string>){
            state.my.email = action.payload;
        },
        setRole(state, action: PayloadAction<IMy['role']>){
            state.my.role = action.payload;
        },
        setRoleName(state, action: PayloadAction<string>){
            state.my.role_name = action.payload;
        },
        setId(state, action: PayloadAction<number>){
            state.my.id = action.payload;
        },
        setFullName(state, action: PayloadAction<string>){
            state.my.full_name = action.payload;
        },
        setAvailableFeatures(state, action: PayloadAction<string[]>){
            state.my.available_features = action.payload;
        },
        setFeatureGrants(state, action: PayloadAction<IMyFeatureGrant[]>){
            state.my.feature_grants = action.payload;
        },
    }
})

export const myReducer =  MySlice.reducer
